export function trackSubscribe() {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", "Subscribe");
  }
}
